// @flow
import { useCallback, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

/**
 * @deprecated Use const setSearchParams() from react router v6 instead
 */
const useReplaceQueryString = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchRef = useRef();

  useEffect(() => {
    searchRef.current = location.search;
  }, [location, searchRef]);

  return useCallback(
    (func) => {
      const parsed = queryString.parse(searchRef.current, {
        arrayFormat: 'bracket'
      });

      const newQuery = func(parsed);

      navigate({
        search: queryString.stringify(newQuery, {
          arrayFormat: 'bracket'
        }),
        replace: true
      });
    },
    [searchRef, navigate]
  );
};

export default useReplaceQueryString;
